import React from "react";
import { Stack, Typography, Box } from "@mui/joy";
import { CardMedia } from "@mui/material";
import ChargeurDePage from "./ChargeurDePage";
import Marquee from "react-fast-marquee";
import { IMAGES ,PARTENAIRE_IMAMGE } from "../../constant";


const PageAccueil: React.FC = () => {
    return (
        <Stack
            sx={{ 
                backgroundColor: "#F4F9F2", 
                height: "100%", 
                width: "100%", 
                position: "relative",
                overflow: "hidden" ,
                gap: 2
            }}
        >
            <Stack
                sx={{
                    
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    flex: 1, 
                    zIndex: 2, 
                    mt: -8,
                }}
            >
                <ChargeurDePage />
                
                <Stack direction="row" gap={'7vw'} justifyContent="center" alignItems={'center'}>
                    <CardMedia
                        component="img"
                        src={IMAGES.logo}
                        alt="Logo sim tchad"
                        sx={{ width: '12vw', height: "auto", objectFit: 'contain' }}
                    />
                    <CardMedia
                        component="img"
                        src={IMAGES.renfort}
                        alt="Logo de renfort"
                        sx={{ width: '10vw', height: "auto", objectFit: 'contain' }}
                    />
                    <CardMedia
                        component="img"
                        src={IMAGES.logo_fida}
                        alt="Logo fida"
                        sx={{ width: '10vw', height: "auto", objectFit: 'contain' }}
                    />
                </Stack>

                <Box sx={{ mt: 5, width: "100%" }}>
                    <Typography level="h4" fontSize="2vw" fontWeight="md" mb={2}>
                        Nos différents Partenaires
                    </Typography>

                    <Marquee gradient={false} speed={50}>
                        <Stack direction="row" spacing={6} sx={{ py: 2, px: 4 }}>
                            {PARTENAIRE_IMAMGE.map((partenaire, index) => (
                                <CardMedia
                                    component="img"
                                    src={partenaire}
                                    alt={`Partenaire ${index + 1}`}
                                    key={index}
                                    sx={{ 
                                        width: '8vw', 
                                        height: "auto", 
                                        objectFit: 'contain',
                                        backgroundColor: "white",
                                        padding: "0.8vw",
                                        borderRadius: "0.8vw",
                                        boxShadow: "0px 4px 10px rgba(189, 195, 199, 0.4)"
                                    }}
                                />
                            ))}
                        </Stack>
                    </Marquee>
                </Box>

                <Typography level="h4" fontSize="2.5vw" fontWeight="md" sx={{ mt: -2 }}>
                    Système d'informations sur les Marchés  <span style={{ fontWeight: "bold", color:"#1b5e20" }}> Agro-Sylvo-pastoraux au Tchad</span>
                </Typography>
            </Stack>

            {/* Image de fond à gauche agrandie */}
            <Box 
                component="img" 
                src={IMAGES.bg1} 
                alt="Décoration 1" 
                sx={{ 
                    position: "absolute",
                    left: -90,
                    bottom: -160,
                    height: "70vh", // Augmenté pour qu'elle soit plus grande
                    width: "auto",
                    zIndex: 1,
                    opacity: 0.8, // Optionnel : pour ne pas masquer le contenu
                    pointerEvents: "none" // Pour ne pas gêner les clics
                }} 
            />
        </Stack>
    );
};

export default PageAccueil;
